import type { UserContactCardProps } from "./types-user-contact-card";
import { useUserContactCard } from "./use-user-contact-card";
import { UserContactCardView } from "./view-user-contact-card";

/** Cartão de contato do usuário: foto, nome, e-mail com copiar, telefone e detalhe, com título opcional. */
export function UserContactCard(props: UserContactCardProps) {
  const vm = useUserContactCard(props);

  return <UserContactCardView {...vm} />;
}

export type * from "./types-user-contact-card";
